import { useCallback, useEffect } from 'react';

export const useUnloadDialog = (enable: boolean) => {
  // ユーザーがページを離れようとしたときに警告を表示します
  // see: https://developer.mozilla.org/ja/docs/Web/API/Window/beforeunload_event
  const handleBeforeUnload = useCallback((e: BeforeUnloadEvent) => {
    e.preventDefault();
    e.returnValue = '';
  }, []);

  useEffect(() => {
    if (!enable) return;

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [enable, handleBeforeUnload]);
};
